import { configureStore } from '@reduxjs/toolkit';
import * as Sentry from '@sentry/react';
import saga from 'redux-saga';

import { isSentryEnabled } from '../configs/sentry';
import rootReducer from './rootReducer';
import rootSaga from './rootSaga';

const sagaMiddleware = saga();

const sentryReduxEnhancer = Sentry.createReduxEnhancer();

const store = configureStore({
  reducer: rootReducer,
  enhancers: (defaultEnhancers) => (isSentryEnabled ? defaultEnhancers.concat(sentryReduxEnhancer) : defaultEnhancers),
  middleware: [sagaMiddleware],
  devTools: process.env.NODE_ENV !== 'production',
});

sagaMiddleware.run(rootSaga);

export type RootState = ReturnType<typeof store.getState>;

export default store;
